export default {
    INFO: 'INFO',
    ERROR: 'ERROR'
}
